import React, { useState } from 'react';
import { Accordion, Box, Grid, TextInput, Select, Button } from '@mantine/core';

type Field = {
  label: string;
  type: 'text' | 'dropdown' | 'select';
  options?: { label: string; value: any }[];
  value: any;
};

export type AccordionData = {
  name: string;
  fields: Field[];
};

interface FormAccordionProps {
  data: AccordionData[];
  handleSubmit(e:any):any
}

const FormAccordion: React.FC<FormAccordionProps> = ({ data,handleSubmit }) => {
  // Create a local state to manage the form data
  const [formData, setFormData] = useState<AccordionData[]>(data);

  // Function to handle changes in the input fields
  const handleInputChange = (sectionIndex: number, fieldIndex: number, newValue: any) => {
    const updatedFormData = [...formData];
    updatedFormData[sectionIndex].fields[fieldIndex].value = newValue;
    setFormData(updatedFormData);
  };

  return (
    <>
      <Accordion defaultValue={data[0]?.name ?? ''}>
        {formData.map((section, sectionIndex) => (
          <Accordion.Item value={section.name} key={sectionIndex}>
            <Accordion.Control sx={{ backgroundColor: '#f7f7f7' }}>
              {section.name}
            </Accordion.Control>
            <Accordion.Panel>
              <Box p="sm">
                <Grid>
                  {section.fields.map((field, fieldIndex) => {
                    const isLastAndOdd = (fieldIndex === section.fields.length - 1) && (section.fields.length % 2 !== 0);
                    const colSpan = isLastAndOdd ? 12 : 6;

                    return (
                      <Grid.Col span={colSpan} key={fieldIndex}>
                        {field.type === 'text' && (
                          <TextInput
                            label={field.label}
                            value={field.value}
                            onChange={(event) =>
                              handleInputChange(sectionIndex, fieldIndex, event.currentTarget.value)
                            }
                            placeholder={`Enter ${field.label}`}
                          />
                        )}
                        {(field.type === 'dropdown' || field.type === 'select') && field.options && (
                          <Select
                            value={field.value}
                            label={field.label}
                            placeholder={`Select ${field.label}`}
                            data={field.options}
                            onChange={(newValue) => handleInputChange(sectionIndex, fieldIndex, newValue)}
                          />
                        )}
                      </Grid.Col>
                    );
                  })}
                </Grid>
              </Box>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '16px' }}>
        <Button onClick={()=> handleSubmit(formData)}>Submit</Button>
      </Box>
    </>
  );
};

export default FormAccordion;
